module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/zh-hans/5/4-b86289430983caee43304d0450cf2caa.jpg";